import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UnloadTypePumpCodes } from '@ordersnproducts/modules/shared/models/pump-type.enum';
@Injectable()
export class HandleCleanUp implements OnFieldChanged {
  private pumpCodes;

  constructor() {
    this.pumpCodes = Object.keys(UnloadTypePumpCodes).map((code) => UnloadTypePumpCodes[code]);
  }

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    const hide = !this.shouldShowPump(String(value).toUpperCase());

    if (hide) {
      form.setValue(SpecFieldNames.CLEAN_UP, false);
    }
    form.setDisabled(SpecFieldNames.CLEAN_UP, hide);
    form.setHidden(SpecFieldNames.CLEAN_UP, hide);
  }

  shouldShowPump(value: string): boolean {
    return this.pumpCodes.includes(value);
  }
}
